import { LocalizationService, LocalizationApi } from "./localization";
import {
  Prerequisite,
  PrerequisiteLoadingService
} from "../../ServiceDesk/sdServices/loading/prerequisite-loading-service";
import sdLocalizationModule from "./localizationModule";

// @ngInject
sdLocalizationModule
  .service("sdLocalizationService", LocalizationService)
  .filter("loc", [
    "sdLocalizationService",
    function (sdLocalizationService: LocalizationApi) {
      return function (input: string, subAppId: string) {
        if (!input) {
          return "";
        }
        return sdLocalizationService.getLocalizedString(subAppId, input);
      };
    }
  ])
  .run((prerequisiteLoadingService: PrerequisiteLoadingService, sdLocalizationService: LocalizationService) => {
    prerequisiteLoadingService.registerCallbackForPrerequisite(
      "sdLocalizationService",
      (prerequisite: Prerequisite) => {
        return sdLocalizationService.prerequisiteLoadCallback(prerequisite);
      },
      false
    );
  });
